export const FIELDS = {

  ID: 'id',
  INVENTORY_ID: 'inventoryId',
  QUANTITY: 'quantity',
  DATE_CODE: 'dateCode',
  LOT_CODE: 'lotCode',
  REVISION: 'revision',
  CONDITION_ID: 'conditionId',
  COUNTRY_OF_ORIGIN_ID: 'countryOfOriginId',
  COMMENTS: 'comments',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  ACTIVE: 'active',
  CONDITION_NAME: 'conditionName',
  COUNTRY_OF_ORIGIN_NAME: 'countryOfOriginName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
};